/**
 * 브라우저 SubtleCrypto로 파일의 SHA-256 해시(hex)를 계산.
 *
 * 사용 목적: 같은 파일을 중복으로 비동기 요청 보내는 것을 백엔드에서 차단하기 위함.
 * - 평균 1.85MB: ~10ms 미만
 * - 최대 78MB: ~500ms 수준 (브라우저 메인 스레드 부담 미미)
 *
 * crypto.subtle은 secure context(https) 필수. dev 서버는 http이므로
 * localhost 또는 isSecureContext 환경에서만 계산되고, 그 외엔 undefined 반환한다.
 */
export async function computeFileSha256(file: File): Promise<string | undefined> {
  if (typeof crypto === "undefined" || !crypto.subtle) {
    return undefined;
  }

  try {
    const buffer = await file.arrayBuffer();
    const digest = await crypto.subtle.digest("SHA-256", buffer);
    return bufferToHex(digest);
  } catch {
    return undefined;
  }
}

function bufferToHex(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let hex = "";
  for (let i = 0; i < bytes.length; i++) {
    hex += bytes[i].toString(16).padStart(2, "0");
  }
  return hex;
}
